import Vue from 'vue'
import Vuex from 'vuex'
import { login, logout, loginByPhone, loginByDevice } from '@/api/login'
import { getInfo } from '@/api/user/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import md5 from 'js-md5'
Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        token: getToken(),
        info: {}

    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },

        SET_INFO: (state, info) => {
            state.info = info
        }

    },
    actions: {
        LoginByToken({ commit }, token) {
            return new Promise((resolve, reject) => {
                commit('SET_TOKEN', '')
                commit('SET_INFO', {})
                removeToken()
                setToken(token)
                commit('SET_TOKEN', token)
                resolve()
            })
        },
        // 登录
        Login({ commit }, userInfo) {
            const a = {}
            Object.assign(a, userInfo)
            a.password = md5(userInfo.password + 'shuaigege')
            a.username = userInfo.phone.trim()
            a.phone = userInfo.phone.trim()
            return new Promise((resolve, reject) => {
                login(a)
                    .then(response => {
                        const data = response.data
                        setToken(data.access_token)
                        commit('SET_TOKEN', data.access_token)
                        resolve()
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        SWITCH_USER({ commit }, data) { 
            setToken(data.access_token)
            commit('SET_TOKEN', data.access_token)
        },
        LoginByDevice({ commit }, data) {
            return new Promise((resolve, reject) => {
                loginByDevice(data)
                    .then(response => {
                    
                        const data = response.data
                        setToken(data.access_token)
                        commit('SET_TOKEN', data.access_token)
                        resolve()
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // 通过手机验证码登录
        LoginByPhone({ commit }, userInfo) {
            return new Promise((resolve, reject) => {
                loginByPhone(userInfo)
                    .then(response => {
                        const data = response.data
                        setToken(data.access_token)
                        commit('SET_TOKEN', data.access_token)
                        resolve()
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // 获取用户信息
        GetInfo({ commit, state }) {
            return new Promise((resolve, reject) => {
                getInfo()
                    .then(response => {
                        const data = response.data
                        commit('SET_INFO', data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // 登出
        LogOut({ commit, state }) {
            return new Promise((resolve, reject) => {
                logout()
                    .then(() => {
                        commit('SET_TOKEN', '')
                        commit('SET_INFO', {})
                        removeToken()
                        resolve()
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // 前端 登出
        FedLogOut({ commit }) {
            return new Promise(resolve => {
                commit('SET_TOKEN', '')
                removeToken()
                resolve()
            })
        }
    }

})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js